export default {
	authAdminTokenKey: "x-admin-auth-token",
	authAccountTokenKey: "x-account-auth-token"
}
